var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,25c150.2,0,299.7,0,450,0c0,150.2,0,299.7,0,450c-150.2,0-299.7,0-450,0C25,324.8,25,175.3,25,25z M305.8,398.7 c-1.4,5.3-4.2,12.8-5.2,20.5c-0.4,3,2.7,8.4,5.5,9.5c30.6,12.3,61.7,14.1,92.1,0.3c22.8-10.4,34-29.1,33.6-54.5 c-0.3-23.1-12.8-38.5-32.1-48.7c-14.1-7.5-29.2-13.1-43.5-20.3c-10.6-5.4-18.1-13.8-15.2-26.8c2.9-13,12.6-20.1,25.2-19.9 c16.1,0.3,32.1,3.1,49.7,5c2.1-7,4.9-16.2,8-26.6c-30.1-12.8-59.3-15.1-88.5-1.8c-20.7,9.4-32.5,26-33.1,49.3 c-0.6,22.5,11.1,38.2,29.9,48.5c12.4,6.8,25.9,11.6,38.9,17.4c17.6,7.7,24.8,18.7,22.1,33.7c-2.2,12.4-14.1,22.3-31.3,21.7 C344,405.7,326.2,401.6,305.8,398.7z M228,434.6c0-58,0-114.4,0-172.5c20,0,38.9,0,57.4,0c0-11.4,0-20.9,0-30.7 c-51.5,0-102,0-153.2,0c0,10.5,0,20,0,31.2c19.2,0,37.6,0,57.8,0c0,58.3,0,114.9,0,172.1C203.2,434.6,214.5,434.6,228,434.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/TS.1a26cff272bc63ad1307c47f62b55e4f.svg";
export { ForwardRef as ReactComponent };